import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

import 'swiper/css/bundle'

const slidermathPdf = () => {
  let swiper

  function initSwiper () {
    const screenWidth = document.documentElement.clientWidth

    if (screenWidth < 768 && swiper === undefined) {
      swiper = new Swiper('#math-pdf', {
        modules: [Navigation],
        grabCursor: true,
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 8,
        navigation: {
          nextEl: '#math-pdf .navigation .navigation-button-next',
          prevEl: '#math-pdf .navigation .navigation-button-prev'
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 16
          }
        }
      })
    } else if (screenWidth > 767 && swiper !== undefined) {
      swiper.destroy(true, true)
      swiper = undefined
      document.querySelector('#math-pdf .swiper-wrapper').removeAttribute('style')
      document.querySelector('#math-pdf .swiper-slide').removeAttribute('style')
    }
  }
  initSwiper()
  window.addEventListener('resize', function () {
    initSwiper()
  })
}

export default slidermathPdf
